<template>
	<div class="cnt-view-images">
		<template v-if="imagens.length == 0">
			<div class="img-principal"></div>
		</template>
		<template v-else>
			<ul class="presentation">
				<li
					v-for="(img, idImg) in imagens"
					v-show="presentation == idImg"
					:style="{ backgroundImage: imgPresentation(img).url }"
				>
					<div
						v-if="imgPresentation(img).title != ''"
						class="description"
					>
						{{ imgPresentation(img).title }}
					</div>
				</li>
			</ul>
			<ul class="cnt-miniaturas">
				<li
					v-for="(img, id) in imagens"
					@click="presentation = id"
					:class="{ active: presentation == id }"
					:style="{
						backgroundImage: `url(${$getImage(
							'img-setor/' + img.url
						)})`,
					}"
				>
					<div class="actived">
						<i class="fa fa-eye"></i>
					</div>
				</li>
			</ul>
		</template>
	</div>
</template>
<script>
	export default {
		data() {
			return {
				presentation: 0,
			};
		},
		props: ['imagens'],
		methods: {
			imgPresentation(img) {
				return {
					title: img.title,
					url: `url(${this.$getImage('img-setor/' + img.url, 400)})`,
				};
			},
		},
	};
</script>
<style scoped>
	.cnt-miniaturas {
		list-style: none;
		padding: 0px;
	}
	.cnt-miniaturas li {
		width: 23%;
		margin: 1%;
		height: 77px;
		float: left;
		background-position: center;
		background-repeat: no-repeat;
		background-size: cover;
		border: 1px solid #cecece;
		border-radius: 5px;
		cursor: pointer;
		position: relative;
		opacity: 0.5;
	}

	.cnt-miniaturas li:hover,
	.cnt-miniaturas li.active {
		opacity: 1;
	}

	.cnt-miniaturas .actived {
		position: absolute;
		background: rgba(0, 0, 0, 0.5);
		width: 100%;
		height: 100%;
		color: #fff;
		font-size: 28px;
		text-align: center;
		line-height: 73px;
		display: none;
	}

	.active .actived {
		display: block;
	}

	.presentation {
		list-style: none;
		padding: 1%;
	}
	.presentation li {
		width: 100%;
		display: block;
		height: 330px;
		background-position: center;
		background-size: cover;
		background-repeat: no-repeat;
		border: 1px solid #cecece;
		border-radius: 5px;
		position: relative;
	}
	.presentation li .description {
		background: rgba(0, 0, 0, 0.6);
		color: #fff;
		text-align: justify;
		line-height: 14px;
		padding: 15px;
		position: absolute;
		bottom: 0;
	}

	.img-principal {
		background-image: url('../../../../../../../../assets/imgs/sem-imagem.png');
		width: 100%;
		height: 335px;
		background-position: center;
		background-repeat: no-repeat;
		background-size: contain;
		border: 1px solid #cecece;
		border-radius: 5px;
	}
</style>



// WEBPACK FOOTER //
// src/components/sst/seguranca/components/dimencionamento/components/itemSetor/components/ManipulacaoDeImagens.vue